// npm packages
import { Col, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// assets
import { CodeSlash, BoxSeam } from "react-bootstrap-icons";
import InternetIcon from "../assets/img/sources/Internet";
import FigmaIcon from "../assets/img/sources/Figma";

// project imports
import { TooltipWrapper } from "./TooltipWrapper";

// styles
import "./ProjectCard.css";

const websiteIcons = {
  demo: <InternetIcon size="1rem" />,
  code: <CodeSlash size="1rem" />,
  figma: <FigmaIcon size="1rem" />,
  package: <BoxSeam size="1rem" />,
};

export const ProjectCard = ({
  title,
  titleKey,
  description,
  descriptionKey,
  imgUrl,
  websites,
}) => {
  const { t } = useTranslation();

  const displayTitle = titleKey ? t(titleKey) : title;
  const displayDescription = descriptionKey ? t(descriptionKey) : description;

  return (
    <Col size={12} sm={12} md={6} lg={4}>
      <div className="project-card">
        <div className="project-card__body">
          <div className="project-card__image-container">
            <img className="project-card__image" src={imgUrl} alt="title" />
          </div>
          <div className="project-content">
            <div className="project-header-section">
              <h4 className="project-card__title">{displayTitle}</h4>
            </div>
            <span className="project-card__description">{displayDescription}</span>
          </div>

          <Nav className="gap-2">
            {websites.map((item, i) => (
              <Nav.Item key={i}>
                <TooltipWrapper
                  tooltip={t(`projectCard.tooltip.${item.type}`)}
                  position={"left"}
                >
                  <Nav.Link
                    className="square-button"
                    href={item.url}
                    target="_blank"
                  >
                    {websiteIcons[item.type] || "no icon"}
                  </Nav.Link>
                </TooltipWrapper>
              </Nav.Item>
            ))}
          </Nav>
        </div>
      </div>
    </Col>
  );
};
